import { environment } from './../../../../../../environments/environment';

export class AuthConstants {
    static readonly SLASH = '/';
    static readonly COGNITO_IDENTITY_URL = `https://cognito-identity.${environment.region}.amazonaws.com/`;
    static readonly PROVIDER_LOGIN_KEY = `cognito-idp.${environment.region}.amazonaws.com/${environment.userPoolId}`;
}
